import Segment from '@/creditflowresearch/domain/Segment/Segment';
import { MarketSegment } from '@/creditflowresearch/domain/Market/types/MarketSegment';
import { SSA_SEGMENT_ID } from '@/creditflowresearch/domain/Segment/constants';

class SsaSegment extends Segment {
  static readonly SEGMENT_ID: string = SSA_SEGMENT_ID;

  static readonly TYPE: MarketSegment = MarketSegment.SSA;
}

export default SsaSegment;
